const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteDuda = async ( id_aula : string, id_usuari : string, estat : number ) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/dubtes`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id_aula, id_usuari, estat })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
